import React, { useEffect, useState } from 'react';
import { documentService } from '../../../services/central-api/document';
import FilterBadgeSearchList, { FilterListItem } from '../Dispatch/FilterBadgeSearchList';

type Props = {
    actingBodyId?: number | null;
    actingBodyUnitIds?: number[];
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
};

function DocumentUsersList({ value, setValue, actingBodyId, actingBodyUnitIds }: Props) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getUsers(actingBodyId: number, actingBodyUnitIds?: number[]) {
        try {
            setIsLoading(true);
            const users = await documentService.getDocumentUsers({ actingBodyId, actingBodyUnitIds });
            setItems(users.map((user) => ({
                value: user.id,
                label: user.warName || user.name,
            })));
        } catch (err) {
            console.error(err);
            setItems([]);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (actingBodyId && actingBodyId > 0) {
            getUsers(actingBodyId, actingBodyUnitIds);
        } else {
            setItems([]);
            setIsLoading(false);
        }
    }, [actingBodyId, JSON.stringify(actingBodyUnitIds)]);

    return <FilterBadgeSearchList items={items} value={value} setValue={setValue} isLoading={isLoading} />;
}

export default DocumentUsersList;
